import axiosInstance from '../routes/axios-instance';
import handlerError from '../routes/error-handler';
import RoutesAPI from '../routes/api.routes';

export const AppModel = {
  id: 0,
  name: '',
  authToken: '',
};

export default {
  namespaced: true,
  state: {
    app: { ...AppModel },
    apps: [],
  },
  mutations: {
    add(state, element) {
      state.apps.push(element);
    },
    editApp(state, element) {
      state.app = element;
    },
    editApps(state, apps) {
      state.apps = apps;
    },
    updateApp(state, element) {
      state.apps = state.apps.map((value) => (element.id === value.id ? element : value));
    },
    deleteAction(state, id) {
      state.apps = state.apps.filter((app) => app.id !== id);
    },
  },
  actions: {
    async getApp({ commit }, id) {
      axiosInstance.get(`${RoutesAPI.GET_ALL_APPS}/${id}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('editApp', response.data);
          }
        })
        .catch(handlerError);
    },
    async getApps({ commit }) {
      axiosInstance.get(RoutesAPI.GET_ALL_APPS)
        .then((response) => {
          commit('editApps', response.data);
        })
        .catch(handlerError);
    },

    async create({ commit }, body) {
      axiosInstance.post(RoutesAPI.GET_ALL_APPS, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('add', response.data);
          }
        })
        .catch(handlerError);
    },

    async update({ commit }, { id, body }) {
      axiosInstance.put(`${RoutesAPI.GET_ALL_APPS}/${id}`, body)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateApp', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, id) {
      axiosInstance.delete(`${RoutesAPI.GET_ALL_APPS}/${id}`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('deleteAction', id);
          }
        })
        .catch(handlerError);
    },
  },
  getters: { },
};
